// extracted by mini-css-extract-plugin
export var readonly = "_fn-1";
export var star = "_fn-0";